module.exports = __webpack_public_path__ + "static/media/best-sustainable.5281bb0b.png";